













































































































import { Component, Vue, Watch } from "vue-property-decorator";
import ResepObatSvc from "@/services/ResepObat";
import OrderBmhpInputCard from "@/components/pemeriksaan/resep-obat/OrderBmhpInputCard.vue";
import { orderBmhpStore } from "@/store/modules/OrderBmhp";
import moment from "moment";
import { userModule } from "@/store/modules/user";

@Component({
  components: {
    OrderBmhpInputCard
  },
  inject: { isReadOnly: { default: () => () => false } }
})
export default class OrderBmhpList extends Vue {
  isReadOnly!: () => boolean;
  get readOnly(): boolean {
    return this.isReadOnly();
  }

  headers = [
    {
      text: "Tanggal",
      align: "start",
      value: "tanggal"
    },
    { text: "Unit", value: "unit.nama" },
    { text: "User", value: "dokter.nama" }
  ];

  get loading() {
    return orderBmhpStore.listLoading;
  }

  expanded = [];

  saving = false;

  get register() {
    return this.$route.params.register;
  }

  get orderList() {
    return orderBmhpStore.order
      .filter(item => item.unit.id >= "50")
      .sort(
        (a, b) =>
          new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
      );
  }

  showOrderBmhpInput = false;
  search = null;
  entries = [];
  isLoading = false;

  orderId = null;
  items: {
    id: number;
    obat_id: string;
    obat_nama: string;
    qty: string;
    qty_unit: string;
    harga: string;
    countedHarga: string;
    ap_dosis: string;
    ap_tambahan: string;
    ap_template_id: string;
    ap_template_nama: string;
    frekuensi_id: string;
    rute_id: string;
    r: string;
    stopped_at: string;
  }[] = [];

  editedItem = null;

  getOrderList() {
    orderBmhpStore.getOrderByRegister(this.register);
    this.expanded = [];
  }

  get canAddOrder() {
    return userModule.canAccessForm("permintaan_bmhp", "create");
  }

  depoId = "03";
  pasienRm = null;
  tanggal = moment().format("yyyy-mm-dd");

  // get orderInput() {
  //   return {
  //     id: this.orderId,
  //     depo_id: this.depoId,
  //     bb: null,
  //     alergi: null,
  //     diagnosis: null,
  //     user_id: userModule.user.id,
  //     unit_id: userModule.user.unit_id,
  //     pasien_cm: this.pasienRm,
  //     register_id: this.register,
  //     tanggal: this.tanggal,
  //     status: "1",
  //     items: this.items,
  //     kategori: "a"
  //   };
  // }

  // get orderInputRecord() {
  //   return "";
  // }

  _timerId = null;

  @Watch("search")
  changedSearch(val) {
    this.entries = [];

    clearTimeout(this._timerId);

    console.log("changed search", val);

    this._timerId = setTimeout(() => {
      if (this.search === null || this.search.length < 3) return;

      this.isLoading = true;

      ResepObatSvc.getRefObat(val, "a")
        .then(res => {
          this.entries = res.data;
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => (this.isLoading = false));
    }, 300);
  }

  selectItem(val, index) {
    console.log("select item", val, index);

    // this.search = null;
    // this.entries = [];

    // if (val) {
    //   this.items.push({
    //     id: null,
    //     obat_id: val.id,
    //     obat_nama: val.nama,
    //     qty: null,
    //     qty_unit: val.satuan,
    //     harga: val.harga,
    //     countedHarga: null,
    //     ap_dosis: null,
    //     ap_tambahan: null,
    //     ap_template_id: null,
    //     ap_template_nama: null,
    //     aturan_pakai: null,
    //     frekuensi: null,
    //     rute: null,
    //     r: "",
    //     stopped_at: null
    //   });
    // }
  }

  addOrder() {
    if (this.readOnly) return;
    // this.orderId = null;
    // this.pasienRm = this.$route.params.rm;
    // this.depoId = "03";
    // this.tanggal = moment().format("YYYY-MM-DD");
    // this.items = [];

    this.showOrderBmhpInput = true;
  }

  editOrder(item) {
    if (this.readOnly) return;
    if (item.dokter?.id == userModule.user.id && item.status < 2) {
      this.editedItem = item;

      this.showOrderBmhpInput = true;
    } else if (item.status >= 2) {
      alert("tidak dapat mengubah order karena sudah diproses Inst. Farmasi!");
      return false;
    } else if (item.dokter?.id != userModule.user.id) {
      alert("tidak dapat mengubah order yang dibuat orang lain!");
      return false;
    }
  }

  closeOrderInput() {
    this.editedItem = null;
    this.showOrderBmhpInput = false;
  }

  parseIconName(status) {
    if (status <= 1) {
      return "mdi-send";
    } else {
      return "mdi-check-circle";
    }
  }

  parseIconColor(status) {
    if (status == 0) {
      return "";
      // } else if (status == 1) {
      //   return "warning";
    } else {
      return "success";
    }
  }

  parseStatusToText(status) {
    if (status == 0) {
      return "belum dikirim";
    } else if (status == 1) {
      return "terkirim";
    } else {
      return "terlayani";
    }
  }

  expandRow(item) {
    this.expanded.includes(item)
      ? (this.expanded = [])
      : (this.expanded = [item]);
  }

  printLembarBmhp() {
    ResepObatSvc.printLembarBmhp(this.register);
  }
}
